export default __webpack_public_path__ + "static/media/imagenine.ec468f0c.gif";